import { render, staticRenderFns } from "./sign-attribute-modal.vue?vue&type=template&id=07993ad8&scoped=true&"
import script from "./sign-attribute-modal.vue?vue&type=script&lang=ts&"
export * from "./sign-attribute-modal.vue?vue&type=script&lang=ts&"
import style0 from "./sign-attribute-modal.vue?vue&type=style&index=0&id=07993ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07993ad8",
  null
  
)

export default component.exports